<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="6.5" width="18" height="4" rx="1" stroke="#222221" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M4.5 10.5V17.5C4.5 18.6046 5.39543 19.5 6.5 19.5H17.5C18.6046 19.5 19.5 18.6046 19.5 17.5V10.5" stroke="#222221" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M12 6.5V19.5" stroke="#222221" stroke-width="1.5" />
    <path d="M12 6.5C10.5 3.5 7.6 2.5 6.8 4.1C6.1 5.5 8.5 6.5 12 6.5Z" stroke="#222221" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M12 6.5C13.5 3.5 16.4 2.5 17.2 4.1C17.9 5.5 15.5 6.5 12 6.5Z" stroke="#222221" stroke-width="1.5" stroke-linejoin="round" />
  </svg>
</template>
